import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './Pages/Home';
import QuotePage from './components/ContactForm/QuotePage';
import ScrollToTop from './components/ScrollToTop';
import AutomobileLogistics from './Pages/AutomobileLogistics/AutomobileLogistics';
import ChassisTransport from './Pages/ChassisTransport/ChassisTransport';
import ODC from './Pages/ODC/ODC';
import MiningTransport from './Pages/MiningTransport/MiningTransport';
import Services from './Pages/Services/Services';
import About from './Pages/About/About';
import ContactUs from './Pages/ContactUs/ContactUs';
import Business from './Pages/Business/Business';

function AppContent() {
  const location = useLocation();
  // Hide footer only on QuotePage
  const hideFooter = location.pathname === '/quote';

  return (
    <div className="App">
      <ScrollToTop/>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/services/automobile-logistics" element={<AutomobileLogistics />} />
          <Route path="/services/chassis-transport" element={<ChassisTransport />} />
          <Route path="/services/odc-heavy-cargo" element={<ODC />} />
          <Route path="/services/mining-transport" element={<MiningTransport />} />
          <Route path="/services" element={<Services />} />
          <Route path="/business" element={<Business />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;